/** Detect the user's device platform from the user agent. */
export type DevicePlatform = 'ios' | 'android' | 'desktop';

export function getDevicePlatform(): DevicePlatform {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent || '';

  // iPhone / iPad / iPod (including iPads reporting as MacIntel with touch).
  if (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  ) {
    return 'ios';
  }
  if (/android/i.test(ua)) return 'android';
  return 'desktop';
}

export function platformHealthName(platform: DevicePlatform): string {
  switch (platform) {
    case 'ios':
      return 'Apple Health';
    case 'android':
      return 'Health Connect';
    case 'desktop':
      return 'Health app';
  }
}
